import { RolodexEntryType } from 'types'
import { z } from 'zod'

const TagsSchema = z.record(z.string(), z.string().nullable())
const OptionalTimestamps = z.object({
  updated_at: z.coerce.date().nullish(),
  created_at: z.coerce.date().nullish(),
  last_updated_by: z.string().nullish(),
})

export const TimeSeriesDashboardDataSchema = z
  .object({
    name: z.string().nullish(),
    chart_ids: z.array(z.string()),
  })
  .transform((schema) => ({
    name: schema.name,
    chartIds: schema.chart_ids,
  }))

export const TimeSeriesDashboardEntryJSONSchema = z
  .object({
    id: z.string(),
    type: z.literal(RolodexEntryType.TIME_SERIES_DASHBOARD),
    data: TimeSeriesDashboardDataSchema,
    tags: TagsSchema,
    ...OptionalTimestamps.shape,
  })
  .transform((schema) => ({
    id: schema.id,
    type: schema.type,
    data: schema.data,
    tags: schema.tags,
    ...(schema.updated_at && { updatedAt: schema.updated_at }),
    ...(schema.created_at && { createdAt: schema.created_at }),
    ...(schema.last_updated_by && {
      lastUpdatedBy: schema.last_updated_by,
    }),
  }))

export const TimeSeriesDashboardEntrySchema = z.object({
  entry: TimeSeriesDashboardEntryJSONSchema,
})

export type TimeSeriesDashboardData = z.infer<
  typeof TimeSeriesDashboardDataSchema
>
export type TimeSeriesDashboardEntryJSON = z.infer<
  typeof TimeSeriesDashboardEntryJSONSchema
>
export type TimeSeriesDashboardEntry = z.infer<
  typeof TimeSeriesDashboardEntrySchema
>
